import { createContext, useContext, type RefObject } from 'react';

import { type FileUploadFile } from '../use-file-upload-controller';

export type FileUploadContextValue = {
  handleFileChange: (fileList: FileList | null) => void;
  handleBlur: () => void;
  handleDelete: (index: number) => void;
  files: FileUploadFile[];
  accept: string;
  multiple: boolean;
  limitReached: boolean;
  getExplanationText: () => string | undefined;
  hover: boolean;
  _error?: string;
  buttonRef?: RefObject<HTMLButtonElement>;
  fileRemoveButtonRefs: React.MutableRefObject<{
    [key: string]: RefObject<HTMLButtonElement> | undefined;
  }>;
};

export const FileUploadContext = createContext<
  FileUploadContextValue | undefined
>(undefined);

export function useFileUploadContext(): FileUploadContextValue {
  const context = useContext(FileUploadContext);

  if (typeof context === 'undefined') {
    throw new Error('FileUpload components must be used within FileUpload');
  }

  return context;
}
